import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Tabs, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import Map from "../components/Map";
import { getUserDetails, updateUserProfile } from "../actions/userActions";
import FormContainer from "../components/FormContainer";
import {
  USER_DETAILS_RESET,
  USER_UPDATE_RESET,
} from "../constants/userConstants";
import { useLocation, useNavigate } from "react-router-dom";
import PasswordChecker from "../components/PasswordChecker";
import prefixes from "../data/prefixes";
import { notify } from "../components/notify";
import { FaHome, FaPlus, FaPlusCircle } from "react-icons/fa";
import TextEditor from "../components/TextEditor";
import ClinicVisitScan from "../components/ClinicVisitScan";
import { CLINIC_DETAILS_RESET } from "../constants/clinicConstants";
import { GoCodescanCheckmark } from "react-icons/go";

const UserProfile = () => {
  const [userVehicle, setUserVehicle] = useState(); //to drive useEffect, not displayed
  const [prefixId, setPrefixId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const userLogin = useSelector((state) => state.userLogin);
  const { loading: loadLogin, userInfo } = userLogin;

  const userDetails = useSelector((state) => state.userDetails);
  const { loading: detailsLoading, user, error: detailsError } = userDetails;

  const updatedUserDetails = useSelector((state) => state.updatedUserDetails);
  const { updatedUser, loading, error } = updatedUserDetails;

  const submitHandler = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
    } else {
      setMessage("");
      dispatch(
        updateUserProfile({
          prefixId,
          firstName,
          lastName,
          email,
          password,
          phone,
        }),
      );
    }
  };
  useEffect(() => {
    if (!userInfo) {
      if (!loadLogin) {
        navigate(`/login-screen?returnFrom=${location.pathname}`);
      }
    } else {
      if (!userVehicle) {
        dispatch(getUserDetails(userInfo._id));
      }
      if (user) {
        setUserVehicle(user);
        setPrefixId(user.prefixId);
        setFirstName(user.firstName);
        setLastName(user.lastName);
        setEmail(user.email);
        setPhone(user.phone);

        dispatch({ type: USER_DETAILS_RESET });
      }
      if (updatedUser) {
        setUserVehicle(updatedUser);
        setPrefixId(updatedUser.prefixId);
        setFirstName(updatedUser.firstName);
        setLastName(updatedUser.lastName);
        setEmail(updatedUser.email);
        setPhone(updatedUser.phone);
        dispatch({ type: USER_UPDATE_RESET });
        notify({
          title: "Update Success",
          message: `Your account is updated successfully`,
          type: "success",
          duration: 3000,
        });
        // to load update to clinic details
        dispatch({ type: CLINIC_DETAILS_RESET });
      }
    }
  }, [dispatch, userInfo, userVehicle, loading, user, updatedUser, navigate]);
  return (
    <FormContainer>
      <Map
        titles={[
          {
            idx: "1",
            label: (
              <>
                <FaHome /> Home
              </>
            ),
            path: `/`,
            active: false,
          },
          {
            idx: "2",
            label: "Clinic List Screen",
            path: `/clinic-list-screen`,
            active: false,
          },
          { idx: "3", label: "Profile Screen", path: ``, active: true },
        ]}
      />

      {message && <Message variant="danger">{message}</Message>}
      {detailsError && <Message variant="danger">{detailsError}</Message>}

      {detailsLoading && <Loader />}

      {userVehicle && userInfo && (
        <>
          <h1>{`${
            prefixes.find(
              (p) => p._id.toString() === userInfo.prefixId?.toString(),
            )?.name
          } ${firstName} ${lastName}`}</h1>
          <Form onSubmit={submitHandler}>
            <Row>
              <Form.Group controlId="prefixId" className="col-12 col-lg-4">
                <select
                  className="custom-select"
                  type="name"
                  value={prefixId}
                  onChange={(e) => setPrefixId(e.target.value)}
                >
                  {prefixes.map((p) => (
                    <option key={p._id} value={p._id} disabled={p.disabled}>
                      {p.name}
                    </option>
                  ))}
                </select>
              </Form.Group>

              <Form.Group className="col-12 col-lg-4" controlId="firstName">
                <Form.Control
                  type="name"
                  placeholder="Enter first name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group className="col-12 col-lg-4" controlId="lastName">
                <Form.Control
                  type="name"
                  placeholder="Enter last name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </Row>
            <Row>
              <Col>
                <Form.Group controlId="email">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control readOnly value={email}></Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group controlId="phone">
                  <Form.Label>Whatsapp Phone </Form.Label>
                  <Form.Control
                    type="phone"
                    onChange={(e) => setPhone(e.target.value)}
                    value={phone}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <section id="password">
              <h3>Change Password</h3>

              <Form.Group controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter New Password"
                  value={password}
                  autoComplete="new-password"
                  onChange={(e) => setPassword(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <PasswordChecker password={password} />

              <Form.Group controlId="confirmPassword">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Confirm password"
                  value={confirmPassword}
                  autoComplete="new-password"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                ></Form.Control>
              </Form.Group>
            </section>

            {loading && <Loader />}
            {error && (
              <Message variant="danger" children={`Update Err: ${error}`} />
            )}

            <Button
              className="btn btn-info"
              style={{ float: "right" }}
              type="submit"
            >
              Update Profile Details
            </Button>
          </Form>
        </>
      )}
    </FormContainer>
  );
};

export default UserProfile;
